import React, { FC } from "react";
import styled from "styled-components";
import { tabColor } from "common/constants/Colors";

type Props = {
  state: boolean;
  onClick: () => void;
  className?: string;
  isShowText?: boolean;
  text?: string;
  text_on?: string;
  text_off?: string;
};
const ToggleButton: FC<Props> = ({
  className = "",
  text = "",
  isShowText = true,
  text_on = "",
  text_off = "",
  state = true,
  onClick = () => {}
}) => (
  <Wrapper className={className}>
    <div className="toggle_button" data-state={state} onClick={onClick} />
    {isShowText && (
      <p className="button_text">
        {text}
        {state ? (text_on ? text_on : "ON") : text_off ? text_off : "OFF"}
      </p>
    )}
  </Wrapper>
);

export default ToggleButton;

const Wrapper = styled.div`
  text-align: center;
  width: 60px;
  margin: 0 8px;
  .toggle_button {
    display: block;
    position: relative;
    margin: 0 auto;
    color: #fff;
    background-color: #242424;
    white-space: nowrap;
    border-radius: 5px;
    width: 60px;
    height: 24px;
    transition: background-color 0.3s;
    background-color: #999;
    cursor: pointer;
    &:hover {
      opacity: 0.75;
    }
    &[data-state="true"] {
      background-color: ${tabColor[0]};
      &:after {
        left: 29px;
      }
    }
    &:after {
      content: "";
      position: absolute;
      transition: left 0.3s;
      border-radius: 5px;
      top: 1px;
      left: 1px;
      width: 50%;
      height: 22px;
      background-color: #fff;
    }
  }
  .button_text {
    font-size: 10px;
    text-align: center;
    display: block;
  }
`;
